export var LOGIN_FLOW_START = 'wh.common.command.ui.login.flow.start';
export var REGISTRATION_FLOW_START = 'wh.common.command.ui.registration.flow.start';
export var GPP_FLOW_START = 'wh.common.command.ui.gpp.flow.start';

export var SESSION_STATE_CHANGED = 'wh.common.event.session.state.changed';
export var SESSION_TOKEN_GET_COMMAND = 'wh.common.command.session.token.get';
export var SESSION_TOKEN_GET_EVENT = 'wh.common.event.session.token.get';
//# sourceMappingURL=topics.js.map